<i [attr.data-lucide]="kebabCaseName"></i>